module.exports = __webpack_public_path__ + "img/banner3.7a0153a8.jpg";